const ProgramLabels = {
    ABILITY_TESTS: "abilityTests",
    GLOBAL_CONFIG: "globalConfig",
    QUESTIONNAIRES: "questionnaires",
};

export default ProgramLabels;
